// extracted by mini-css-extract-plugin
export default {"widgets":"addWidget_widgets__3WH1r","widgets-icon-background":"addWidget_widgets-icon-background__STft+","no-data-customers":"addWidget_no-data-customers__L+6Ea"};